import auth from "../../middlewares/auth";

export const userRoutes = [
    {
        path: '/users/:group_id?',
        component: () => import(/* webpackChunkName: "users" */ '../../views/users/User'),
        name: 'users',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['agent-manage']
        }
    },
    {
        path: '/user/:id',
        component: () => import(/* webpackChunkName: "users" */ '../../views/users/UserForm'),
        name: 'update-user',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['agent-manage']
        }
    },
    {
        path: '/create-user',
        component: () => import(/* webpackChunkName: "users" */ '../../views/users/UserForm'),
        name: 'create-user',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['agent-manage']
        }
    },
    {
        path: '/profile',
        component: () => import(/* webpackChunkName: "users" */ '../../views/profile/ProfileIndex.vue'),
        name: 'profile',
        meta: {
            middleware: [
                auth
            ]
        }
    }
]